import { render } from "./ProjetoView.vue?vue&type=template&id=1410584e&scoped=true"
import script from "./ProjetoView.vue?vue&type=script&lang=js"
export * from "./ProjetoView.vue?vue&type=script&lang=js"

import "./ProjetoView.vue?vue&type=style&index=0&id=1410584e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1410584e"]])

export default __exports__